import {HttpService} from "./HttpService";

class ProductTransferService {
    getProductTransfer(productName, additionalRouteInfo = "") {
        return new Promise((resolve, reject) => {
            HttpService.create().post(`/api/user/getProductTransfer/${productName}`, {relativeUrl: additionalRouteInfo})
                .then(result => {
                    const transferResult = result.data;
                    if (transferResult.status === 0 && transferResult.redirectUrl) {
                        window.location.replace(transferResult.redirectUrl);
                    }
                    resolve(result.data);
                })
                .catch(err => reject(err));
        });
    }
}

const svc = new ProductTransferService();
export default svc;
